import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Validators, UntypedFormGroup, UntypedFormControl, FormControl } from '@angular/forms';
import { UtilitiesService } from '../../services/utilities.service';
import { MembershipService } from 'app/core/services/membership.service';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { UtilitiesModel, UtilitiesGroupModel, UtilitiesGroupUtilityModel } from 'app/models/utilities.model';
import { ProviderTaskFieldType } from 'app/enums/provider-task-field-type.enum';
import { UtilityServiceSearchModel } from 'app/signup/models/signup-service.model';
import { NexusFormResultModel } from 'app/core/models/nexus-form-result.model';
import { ProviderModel } from 'app/models/provider.model';
import { faSearch} from '@fortawesome/free-solid-svg-icons';
import { MatSelectChange } from '@angular/material/select';
import { ProviderTaskStepModel } from 'app/models/provider-task-step.model';
import { GroupExpectedBillTaskFieldModel } from 'app/models/group-expected-bill-task-field.model';

@Component({
    selector: 'app-utilities',
    templateUrl: './utilities.component.html',
    styleUrls: ['./utilities.component.css'],
    standalone: false
})
export class UtilitiesComponent extends NexusComponent implements OnInit {
    public utilities_model: UtilitiesModel;
    public current_group: UtilitiesGroupModel;
    public link_forms: Array<UntypedFormGroup>;
    public link_error: Array<string>;
    public link_success: Array<string>;

    public utility_form: UntypedFormGroup;
    public utility_error: string;
    public utility_success: string;

    public ProviderTaskFieldType = ProviderTaskFieldType;
    public utility_services_search_model: Array<UtilityServiceSearchModel>=new Array<UtilityServiceSearchModel>();
    public add_utility=false;
    public providers:Array<ProviderModel>= new Array<ProviderModel>();
    public dropdown_model: Array<any> = new Array<any>();
    public provider_details:ProviderDetailsModel;
    public result_model: NexusFormResultModel = new NexusFormResultModel();
    public add_utility_form = new UntypedFormGroup({
        provider_category_id: new UntypedFormControl('', Validators.required),
        provider_id: new UntypedFormControl('', Validators.required),

      });
      filteredProviders = [];
    searchCtrl:FormControl = new FormControl('');
    showDropdown = false;
    faSearch=faSearch;
    utility_argument_model:UtilityArgumentModel= new UtilityArgumentModel();
    @ViewChild('inputSearchField') input_search_field: ElementRef;
    constructor(private route: ActivatedRoute, private utilities_service: UtilitiesService, private membership: MembershipService) {
        super();
    }

    ngOnInit() {
        this.route.data.subscribe(({ utilities_model,utility_services_search_model }) => {
            this.utilities_model = utilities_model;
            this.utility_services_search_model = utility_services_search_model;
            this.setupUtilities();
        });
        this.add_utility_form.valueChanges.subscribe((form: any) => {
            this.PopulateModelFromForm(form, this.utility_argument_model);
        });
    }

    setupUtilities(){

        if (this.utilities_model.groups.length > 0) {
            this.utilities_model.groups = this.utilities_model.groups.sort(function (a, b) { return (a.end_date > b.end_date) ? 1 : ((b.end_date > a.end_date) ? -1 : 0); }).reverse();
            this.current_group = this.utilities_model.groups[0];
            this.setup_group();
        }
        const existing_categories= this.current_group?.utilities.map(x=>x?.provider?.provider_category_id);
        this.utility_services_search_model= this.utility_services_search_model.filter(x=>!existing_categories.includes(x.provider_category_id));

    }
    get_initial(last_name: string) {
        if (last_name) {
            return last_name.charAt(0);
        }
        return null;
    }

    setup_group() {
        if (this.current_group) {
            this.link_forms = new Array<UntypedFormGroup>();
            this.link_success = new Array<string>();
            this.link_error = new Array<string>();

            for (const utility of this.current_group.utilities) {
                const inputs = {};

                for (const field of utility.fields) {
                    let val = null;
                    switch (field.field_type) {
                        case ProviderTaskFieldType.Date:
                            val = field.value_date;
                            break;
                        case ProviderTaskFieldType.DateTime:
                            val = field.value_date_time;
                            break;
                        case ProviderTaskFieldType.TextArea:
                            val = field.value_text;
                            break;
                        case ProviderTaskFieldType.Numeric:
                            val = field.value_numeric;
                            break;
                        default:
                            val = field.value;
                            break;
                    }

                    inputs[field.id] = new UntypedFormControl({ value: val, disabled: utility.completed_date }, Validators.required);

                    if (field.field_type === 'Password') {
                        inputs[field.id + '_confirm'] = new UntypedFormControl({ value: val, disabled: utility.completed_date }, Validators.required);
                    }
                }

                this.link_forms[utility.id] = new UntypedFormGroup(inputs);
                this.link_error[utility.id] = '';
                this.link_success[utility.id] = '';

                this.link_forms[utility.id].valueChanges.subscribe((form: any) => {
                    for (const field of utility.fields) {
                        switch (field.field_type) {
                            case ProviderTaskFieldType.Date:
                                field.value_date = form[field.id];
                                break;
                            case ProviderTaskFieldType.DateTime:
                                field.value_date_time = form[field.id];
                                break;
                            case ProviderTaskFieldType.TextArea:
                                field.value_text = form[field.id];
                                break;
                            case ProviderTaskFieldType.Numeric:
                                field.value_numeric = form[field.id];
                                break;
                            default:
                                field.value = form[field.id];
                                if (form[field.id + '_confirm']) {
                                    field.value_confirm = form[field.id + '_confirm'];
                                }
                                break;
                        }
                    }
                });
            }
        }
    }

    linkUtility(utility: UtilitiesGroupUtilityModel) {
        this.link_error[utility.id] = '';
        this.link_success[utility.id] = '';

        this.StartSpinner();
        this.utilities_service.PutLinkUtility(utility).subscribe(
            data => {
                this.utilities_model = data;
                for (const group of this.utilities_model.groups) {
                    if (group.id === this.current_group.id) {
                        this.current_group = group;
                        this.setup_group();
                    }
                }

                if (this.utilities_model.groups.every(group => group.all_utilities_linked)) {
                    this.membership.OverrideUtilitiesLinked();
                }

                this.StopSpinner();
                this.link_success[utility.id] = 'Utility Saved!';

            },
            err => {
                this.link_error[utility.id] = err;
                this.StopSpinner();
            });
    }

    showAddutility(){
        this.add_utility= true;
    }
    hideAddUtility(){
        this.add_utility=false;
        this.add_utility_form.reset();
        this.provider_details= null;
    }
    get provider_name():string{
    return this.provider_details.provider_name;
    }
    submit(){
        this.result_model.Reset();
        if (this.add_utility_form.invalid) {
          this.result_model.Incomplete();
          return;
        }
        this.StartSpinner();
        this.utilities_service.GetProviderDetails(this.utility_argument_model.provider_id).subscribe(
            data=>{
                this.provider_details=data;
                this.setupform(this.provider_details);
                this.StopSpinner();

            },
            error=>{
             this.result_model.Error(error);
             this.StopSpinner();
            }
        );


    }

    setupform(data:ProviderDetailsModel){

        this.utility_form = new UntypedFormGroup({});
        if (data) {
            const inputs = {};

            for (const field of data.fields) {

                inputs[field.id] = new UntypedFormControl(null,Validators.required);

                if (field.field_type === 'Password') {
                    inputs[field.id + '_confirm'] = new UntypedFormControl(null,Validators.required);
                }
            }

            this.utility_form = new UntypedFormGroup(inputs);
            this.utility_form.valueChanges.subscribe((form: any) => {
                for (const field of data.fields) {
                    switch (field.field_type) {
                        case ProviderTaskFieldType.Date:
                            field.value_date = form[field.id];
                            break;
                        case ProviderTaskFieldType.DateTime:
                            field.value_date_time = form[field.id];
                            break;
                        case ProviderTaskFieldType.TextArea:
                            field.value_text = form[field.id];
                            break;
                        case ProviderTaskFieldType.Numeric:
                            field.value_numeric = form[field.id];
                            break;
                        default:
                            field.value = form[field.id];
                            if (form[field.id + '_confirm']) {
                                field.value_confirm = form[field.id + '_confirm'];
                            }
                            break;
                    }
                }
            });
        }

    }
    filterProviders() {
        const search = this.searchCtrl.value || '';
        this.filteredProviders = this.providers.filter((provider) =>
          provider.name.toLowerCase().includes(search.toLowerCase())
        );
      }
      onDropdownOpened() {
        this.searchCtrl.setValue('');
        this.input_search_field.nativeElement.focus();
        this.filteredProviders = [...this.providers];
      }
      onOptionChange(event:MatSelectChange){
        this.providers= this.utility_services_search_model.filter(x=>x.provider_category_id===event.value)[0].providers;
        this.filteredProviders = [...this.providers];
        this.add_utility_form.get('provider_id').reset();
        this.provider_details= null;
      }

      postlinkUtility(provider_details){
        provider_details.provider_category_id= this.utility_argument_model.provider_category_id;
        provider_details.provider_id = this.utility_argument_model.provider_id;

        this.StartSpinner();
        this.utilities_service.PutAddUtility(this.provider_details).subscribe(
            data=>{
                this.utilities_model = data;
                this.result_model.Success();
                this.setupUtilities();
                this.hideAddUtility();
                this.StopSpinner();
            },
            error=>{
                this.result_model.Error(error);
                this.StopSpinner();
            }
        );
      }

}
export  class UtilityArgumentModel
{
    public provider_category_id:string;
    public provider_id:string;
}
export class ProviderDetailsModel
{
    public provider_name:string;
    public provider_id:string;
    public provider_category_id:string;
    public  steps:Array<ProviderTaskStepModel>;
    public  fields:Array<GroupExpectedBillTaskFieldModel>;
}
